import { useMutation } from "@/compat/reactQuery";
import actionService from "../../services/actionService";

const useUploadActionAttachments = () =>
  useMutation(actionService.uploadAttachments);

export default useUploadActionAttachments;
